'use client'

import { SegmentedControl } from '@/components/ui/segmented-control'

export interface OptionSwitchProps<T extends string> {
  layoutId?: string
  options: readonly T[]
  value: T
  onChange: (value: T) => void
  className?: string
  labels?: Record<T, string>
}

// Full-width form-row variant of SegmentedControl, keyed by plain string options.
export function OptionSwitch<T extends string>({
  layoutId,
  options,
  value,
  onChange,
  className,
  labels,
}: OptionSwitchProps<T>) {
  return (
    <SegmentedControl
      options={options.map((option) => ({ value: option, label: labels?.[option] ?? option }))}
      value={value}
      onChange={onChange}
      layoutId={layoutId}
      size="md"
      fill
      className={className}
    />
  )
}
